export default __webpack_public_path__ + "static/media/manual-download-hover.fcc991e6.png";